/**
 * Displays a collapsable list of KaTeX rendering errors.
 */
var React = require("react");

var _require = require("aphrodite"),
    css = _require.css,
    StyleSheet = _require.StyleSheet;

var KatexErrorView = React.createClass({
    displayName: "KatexErrorView",

    propTypes: {
        errorList: React.PropTypes.arrayOf(React.PropTypes.shape({
            math: React.PropTypes.string.isRequired,
            message: React.PropTypes.string.isRequired
        })).isRequired
    },

    getInitialState: function getInitialState() {
        return {
            showErrors: false
        };
    },
    handleToggleKatexErrors: function handleToggleKatexErrors(e) {
        this.setState({ showErrors: !this.state.showErrors });
    },
    render: function render() {
        var errorList = this.props.errorList;
        var showErrors = this.state.showErrors;

        // TODO(riley) replace with SVG icons

        var disclosureClass = showErrors ? "icon-chevron-down" : "icon-chevron-right";

        return React.createElement(
            "div",
            { className: css(styles.errorContainer) },
            React.createElement(
                "div",
                {
                    className: css(styles.title),
                    onClick: this.handleToggleKatexErrors
                },
                React.createElement("i", { className: disclosureClass, style: { fontSize: 14 } }),
                "\xA0 KaTeX Errors (",
                errorList.length,
                ")"
            ),
            showErrors && React.createElement(
                "div",
                { className: css(styles.errorExplanation) },
                "These errors will cause your LaTeX to load really slowly for the student. Please fix them if you can. If you can\u2019t because KaTeX doesn\u2019t support the feature you need, please message Cam."
            ),
            showErrors && errorList.map(function (e, index) {
                return React.createElement(
                    "div",
                    { className: css(styles.error), key: index },
                    React.createElement(
                        "div",
                        { style: { color: "red" } },
                        e.math
                    ),
                    React.createElement(
                        "div",
                        null,
                        e.message
                    )
                );
            })
        );
    }
});

var styles = StyleSheet.create({
    title: {
        backgroundColor: "#eee",
        fontSize: "1.25em",
        padding: "4px 10px"
    },
    errorContainer: {
        border: "1px solid #ddd",
        borderTop: "none"
    },
    errorExplanation: {
        padding: "4px 10px",
        backgroundColor: "pink"
    },
    error: {
        padding: "4px 10px"
    }
});

module.exports = KatexErrorView;


/*****************
 ** WEBPACK FOOTER
 ** ./src/katex-error-view.jsx
 ** module id = 89
 ** module chunks = 0 2
 **/